import React from "react";
import { IconButton } from "@sscs/ui";
import {
  ThumbDownIcon as DislikeIcon,
  ThumbDownOutlineIcon as DislikeOutlinedIcon,
  ThumbUpIcon as LikeIcon,
  ThumbUpOutlineIcon as LikeOutlinedIcon,
} from "@sscs/ui/icons";
import { prettifyLargeCount } from "@sscs/utils";
import { Package } from "Types";
import { useLikePackageMutation } from "../../services/softwareCatalog.api";
import { SoftwarePopularity } from "../../types";
import styles from "./likeDislike.module.scss";

type LikeDislikeProps = {
  packageId: string;
  userLike: Package["user_like"];
  popularity: SoftwarePopularity | null;
};

const LikeDislike = ({
  packageId,
  userLike,
  popularity,
}: LikeDislikeProps): React.JSX.Element => {
  const [likePackage] = useLikePackageMutation();

  return (
    <div className={styles["like-dislike"]} data-user-vote={String(userLike)}>
      <div className={styles.vote}>
        <IconButton
          tooltipTitle={userLike === true ? "Remove like" : "Like"}
          size="small"
          className={styles.like}
          onClick={() =>
            likePackage({
              packageId,
              like: userLike === true ? null : true,
            })
          }
        >
          {userLike === true ? <LikeIcon /> : <LikeOutlinedIcon />}
        </IconButton>
        {popularity && (
          <span className={styles.count}>
            {prettifyLargeCount(popularity.likes_count)}
          </span>
        )}
      </div>
      <div className={styles.vote}>
        <IconButton
          tooltipTitle={userLike === false ? "Remove dislike" : "Dislike"}
          className={styles.dislike}
          size="small"
          onClick={() =>
            likePackage({
              packageId,
              like: userLike === false ? null : false,
            })
          }
        >
          {userLike === false ? <DislikeIcon /> : <DislikeOutlinedIcon />}
        </IconButton>
        {popularity && (
          <span className={styles.count}>
            {prettifyLargeCount(popularity.dislikes_count)}
          </span>
        )}
      </div>
    </div>
  );
};

export default LikeDislike;
